import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { NewsQueryKeys } from "modules/NewsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useNewsCategoriesQuery = () =>
  useTypedQuery({
    queryKey: NewsQueryKeys.categoryList,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.categories,
    enabled: useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.Articles)
  });
